import posthog from "posthog-js"
import { EPostHogEventName } from "../../const/const"

export function firePostHogEvent(event: EPostHogEventName) {
    console.log("Fire posthog event:", event)
    posthog.capture(event)
}
